import type { RecallItem } from '$domain/types';
import { db } from '$db/local/db';

export interface RecallGroup {
  key: string;
  nodeId: string;
  nodeName: string;
  items: RecallItem[];
}

export async function buildRecallGroups(items: RecallItem[]): Promise<RecallGroup[]> {
  const byNode = new Map<string, RecallItem[]>();
  for (const item of items) {
    if (!byNode.has(item.nodeId)) byNode.set(item.nodeId, []);
    byNode.get(item.nodeId)!.push(item);
  }
  const groups: RecallGroup[] = [];
  for (const [nodeId, list] of byNode) {
    const node = await db.nodes.get(nodeId);
    groups.push({
      key: nodeId,
      nodeId,
      nodeName: node?.title ?? nodeId.slice(0, 8),
      items: list
    });
  }
  return groups;
}

export const groupKeyOf = (item: RecallItem) => item.nodeId;
export const primaryLabel = (group: RecallGroup) => group.nodeName;
export const secondaryLabel = (group: RecallGroup) => `${group.items.length} items`;